import { all, takeLatest, call, put } from 'redux-saga/effects';
import { Types, loadUserSuccess, loadUserFailure } from './actions';
import { users } from '~/helpers/api';

export function* loadUser({ meta }) {
  const { onSuccess, onFailure, onFinally, isLoginRoute } = meta;
  try {
    const data = yield call(users.findProfile);
    if (
      isLoginRoute &&
      data?.result?.featuresFlag &&
      data?.result?.featuresFlag[0] &&
      data?.result?.featuresFlag[0]?.status === false
    ) {
      const errorMessages = { messages: [{ code: '-16' }] };
      onFailure(errorMessages);
    } else {
      yield put(loadUserSuccess(data?.result));
      onSuccess(data?.result);
    }
  } catch (e) {
    const errorMessages = { messages: e?.messages };
    yield put(loadUserFailure(errorMessages));
    onFailure(errorMessages);
  } finally {
    onFinally();
  }
}

export default all([takeLatest(Types.REQUEST, loadUser)]);
